/**
 * The Check chip (Tasks Both Ways slice 6, 10/28): how many tasks wait for the
 * owner's OK — anything Claude wrote, and each new automatic wording once.
 * Owner / office manager only (settings.manage). Hidden at zero; never the
 * bell. A waiting task counts here and nowhere else.
 */
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function CheckChip() {
    const { can } = useAuth();
    const allowed = can("settings.manage");
    const n =
        useQuery({
            queryKey: ["task-review", "count"],
            queryFn: () => api.get<{ count: number }>("/api/task-review/count"),
            refetchInterval: 60_000,
            enabled: allowed,
        }).data?.count ?? 0;
    if (!allowed || n === 0) return null;
    return (
        <Link
            to="/tasks/check"
            className="door !border-violet-700 !bg-violet-700 !text-white hover:!bg-violet-800"
            data-testid="check-chip"
            aria-label={`Check — ${n} waiting for your OK`}
            title={`${n} waiting for your OK`}
        >
            <ShieldCheck size={15} />
            Check
            <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-white px-2 text-sm font-extrabold tabular-nums text-violet-900">
                {n}
            </span>
        </Link>
    );
}
